export default __webpack_public_path__ + "static/media/collaboImg.dd06345a.png";